import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const REFETCH_CONVERSATION_MESSAGE = createAsyncActionTypes('REFETCH_CONVERSATION_MESSAGE');